<template>
  <NuxtLayout :name="layoutName" :navbar-color="layoutNavbarColor">
    <div v-if="story" class="blogpost">
      <article ref="articleContent">
        <StoryblokComponent :blok="story.content" />
      </article>
      <section class="related-section">
        <div class="container">
          <h2 class="related-section__header">
            Enjoyed this article? Try another!
          </h2>
          <BlogRelatedPosts
            :categories="story.content.categories"
            :uid="story.content._uid"
          />
        </div>
      </section>
      <section class="newsletter-section">
        <div class="container">
          <BlogNewsletterCard />
        </div>
      </section>
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
const blogStore = useBlogStore()
const { slug } = useRoute().params
const { rawDate, articleWordCount } = storeToRefs(blogStore)
const queryParams = {
  resolve_relations: ['sb-blogpost.categories,sb-blogpost.authors'],
}

const { story } = await useFetchStory(`blog/articles/${slug}`, {
  apiOptions: queryParams,
}).catch((error) => {
  throw createError({
    message: error,
    statusCode: 404,
  })
})

if (story.value.content.component === 'sb-page') {
  throw new Error('Unexpected story content type')
}

const { getBreadcrumbsJsonLd } = useBreadcrumbs()

rawDate.value = story.value.first_published_at as string

const noIndex = computed(() => {
  return story.value?.content?.noindex
    ? [
        {
          name: 'robots',
          content: 'noindex',
        },
      ]
    : []
})

useCustomHead(story, {
  metaArgs: noIndex.value,
  jsonLd: getBreadcrumbsJsonLd(),
})
const articleContent = ref()

onMounted(() => {
  articleWordCount.value = articleContent.value
    ?.querySelector('.blogpost__content')
    .textContent.trim()
    ?.split(/\s+/).length
})
false && /*#__PURE__*/ defineI18nRoute({
  locales: ['en'],
})
const { layoutName, layoutNavbarColor } = useLayout<any>(story)
</script>

<style lang="scss">
.newsletter-section {
  background-color: var(--paper-100);
  padding: 0 0 80px;

  @media (min-width: $breakpoint-md) {
    padding: 0 0 128px;
  }

  &__header {
    @include heading-2;

    margin-bottom: var(--space32);
  }
}

.related-section {
  background-color: var(--paper-100);
  padding: 80px 0;

  @media (min-width: $breakpoint-md) {
    padding: 128px 0;
  }

  &__header {
    margin-bottom: 40px;

    @media (min-width: $breakpoint-md) {
      margin-bottom: 56px;
    }
  }
}
</style>
